export const tabsData: any[] = [
  {
    label: "In Pipeline",
    id: "inPipeline",
    count: 0,
    nestedTabs: null,
    stateName: 'Total',
    stateId: undefined,
  },
  {
    label: "Prospect",
    id: "prospect",
    count: 0,
    stateName: 'Prospect',
    stateId: 1,
    nestedTabs: [
      { label: "All", id: "prospect", count: 0, stateName: 'Prospect', stateId: 1 },
      { label: "Automatched", id: "autoMatched", count: 0, stateName: 'Auto-Matched', stateId: 2 },
      { label: "Shortlisted", id: "shortlisted", count: 0, stateName: "Shortlisted", stateId: 8 },
      { label: "Contacted", id: "contacted", count: 0, stateName: "Contacted", stateId: 3 },
      { label: "Responded", id: "responded", count: 0, stateName: "Responded", stateId: 7 },
    ],
  },
  {
    label: "Job Applicant",
    id: "jobApplicant",
    count: 0,
    stateName: 'Job Applicant',
    stateId: 9,
    nestedTabs: [
      { label: "All", id: "jobApplicant", count: 0, stateName: 'Job Applicant', stateId: 9 },
      { label: "Responded", id: "jobApplicantResponded", count: 0, stateName: "Responded", stateId: 30 },
      { label: "Recommended", id: "recommended", count: 0, stateName: "Recommended", stateId: 11 },
      { label: "Inbound", id: "inBoundApplicants", count: 0, stateName: 'Inbound Applicants', stateId: 29 },
      { label: "Matched", id: "matchedApplicants", count: 0, stateName: 'Matched Applicants', stateId: 10 },
      { label: "Others", id: "otherApplicants", count: 0, stateName: "Other Applicants", stateId: 28 },
      // { label: "Applicants", id: "applicants", count: 0, stateName: 'Applicants', stateId: 10 },
      // { label: "Applicants", id: "applicants", count: 0, stateName: 'Applicants', stateId: 28 }
      ],
  },
  {
    label: "Interviewed",
    id: "interviewed",
    stateName: 'Interviewed',
    count: 0,
    stateId: 12,
    nestedTabs: [
      { label: "All", id: "interviewed", count: 0, stateName: 'Interviewed', stateId: 12 },
      { label: "Responded", id: "interviewedResponded", count: 0, stateName: "Responded", stateId: 31 },
      { label: "Phone Screen", id: "phoneScreen", count: 0, stateName: 'Phone Screen', stateId: 13 },
      { label: "HM Screen", id: "hmScreen", count: 0, stateName: 'HM Screen', stateId: 14 },
      { label: "Interview", id: "interview", count: 0, stateName: 'Interview', stateId: 15 },
      { label: "Offer", id: "offer", count: 0, stateName: "Offer", stateId: 16 },
      { label: "Background Check", id: "bgv", count: 0, stateName: "BGV", stateId: 17 },
      { label: "Hired", id: "hired", count: 0, stateName: "BGV", stateId: 18 },
    ],
  },
  {
    label: "Rejected",
    id: "removed",
    count: 0,
    nestedTabs: null,
    stateName: "Removed",
    stateId: 19
  },
];

export const EDUCATION_INSIGHTS_MAP = [
  {
    key: 'top100_asia_engineering_colleges',
    text: 'Top 100 Asia Engineering Colleges'
  },
  {
    key: 'top100_asia_mba_colleges',
    text: 'Top 100 Asia MBA Colleges'
  },
  {
    key: 'top100_asia_colleges',
    text: 'Top 100 Asia Colleges'
  },
  // {
  //   key: 'top100_india_colleges',
  //   text: 'Top 100 India Colleges'
  // },
  {
    key: 'top100_india_engineering_colleges',
    text: 'Top 100 India Engineering Colleges'

  },
  {
    key: 'top100_india_mba_colleges',
    text: 'Top 100 India MBA Colleges'
  },
  {
    key: 'iit_grad',
    text: 'IIT Pass out'
  },
  {
    key: 'iim_grad',
    text: 'IIM Pass out'
  },
  // {
  //     key: 'nit_grad',
  //     text: 'Studied from NIT'
  // },
  // {
  //     key: 'bits_grad',
  //     text: 'Studied from BITS'
  // },
  {
    key: 'fast_phd',
    text: 'PhD in under 4 years'
  },
  // {
  //   key: 'recent_grad',
  //   text: 'Recently Graduated'
  // },
  {
    key: 'world_top_college_grad',
    text: "World's Top College Graduate"
  },
  {
    key: 'top200_college_grad',
    text: 'Top 200 College Graduate'
  },
  {
    key: 'tier1_college_grad',
    text: 'Tier 1 College Graduate'
  },
  // {
  //   key: 'founded_a_company',
  //   text: "Seen company's exit"
  // },
   {
    key: 'from_prestigious_college',
    text: 'Passout from prestigious college'
  },
  // {
  //   key: 'is_post_doc',
  //   text: 'Post Doctoral Researcher'
  // }
  {
    key: 'top10_thailand_mba_colleges',
    text: 'Top 10 Thailand MBA Colleges'
  },
  {
    key: 'top50_thailand_colleges',
    text: 'Top 50 Thailand Colleges',
  },
  {
    key: 'top50_thailand_engineering_colleges',
    text: 'Top 50 Thailand Engineering Colleges',
  },
  {
    key: 'top10_indonesia_mba_colleges',
    text: 'Top 10 Indonesia MBA Colleges',
  },
  {
    key: 'top25_indonesia_engineering_colleges',
    text: 'Top 25 Indonesia Engineering Colleges',
  },
  {
    key: 'top50_indonesia_colleges',
    text: 'Top 50 Indonesia Colleges',
  },
  {
    key: 'top_50_china_colleges',
    text: 'Top 50 China Colleges',
  },
  {
    key: 'top_50_china_engineering',
    text: 'Top 50 China Engineering',
  },
  {
    key: 'top_50_china_mba_colleges',
    text: 'Top 50 China MBA Colleges',
  },
  {
    key: 'top_25_vietnam_colleges',
    text: 'Top 25 Vietnam Colleges',
  },
  {
    key: 'top_25_vietnam_engineering',
    text: 'Top 25 Vietnam Engineering',
  },
  {
    key: 'top_25_hongkong_colleges',
    text: 'Top 25 Hongkong Colleges',
  },
  {
    key: 'top_50_hongkong_engineering_colleges',
    text: 'Top 50 Hongkong Engineering Colleges',
  },
  {
    key: 'top_10_hongkong_mba_colleges',
    text: 'Top 10 Hongkong MBA Colleges',
  },
  {
    key: 'top_50_taiwan_colleges',
    text: 'Top 50 Taiwan Colleges',
  },
  {
    key: 'top_50_taiwan_engineering',
    text: 'Top 50 Taiwan Engineering',
  },
  {
    key: 'top_50_philippines_colleges',
    text: 'Top 50 Philippines Colleges',
  },
  {
    key: 'top_50_philippines_engineering',
    text: 'Top 50 Philippines Engineering',
  },
  {
    key: 'top_25_singapore_colleges',
    text: 'Top 25 Singapore Colleges',
  },
  {
    key: 'top_25_singapore_engineering',
    text: 'Top 25 Singapore Engineering',
  },
  {
    key: 'top_50_uae_colleges',
    text: 'Top 50 UAE Colleges',
  },
  {
    key: 'top_50_uae_engineering',
    text: 'Top 50 UAE Engineering',
  },
  {
    key: 'top_50_saudi_arabia_colleges',
    text: 'Top 50 Saudi Arabia Colleges',
  },
  {
    key: 'top_50_saudi_arabia_engineering',
    text: 'Top 50 Saudi Arabia Engineering',
  },
  {
    key: 'top_25_egypt_colleges',
    text: 'Top 25 Egypt Colleges',
  },
  {
    key: 'top_25_egypt_engineering',
    text: 'Top 25 Egypt Engineering',
  },
  {
    key: 'top_10_qatar_colleges',
    text: 'Top 10 Qatar Colleges',
  },
]
export const gulfInsights = [
    {
      key: "top_10_kuwait_mba_colleges",
      text: "Top 10 Kuwait MBA Colleges"
    },
    {
      key: "top_10_kuwait_colleges",
      text: "Top 10 Kuwait MBA Colleges"
    },
    {
      key: "top_10_kuwait_engineering_colleges",
      text: "Top 10 Kuwait Engineering Colleges"
    },
    {
      key: "top_10_qatar_mba_colleges",
      text: "Top 10 Qatar MBA Colleges"
    },
    {
      key: "top_10_qatar_engineering_colleges",
      text: "Top 10 Qatar Engineering Colleges"
    },
    {
      key: "top_10_bahrain_colleges",
      text: "Top 10 Bahrain Colleges"
    },
    {
      key: "top_10_bahrain_engineering_colleges",
      text: "Top 10 Bahrain Engineering Colleges"
    },
    {
      key: "top_10_bahrain_mba_colleges",
      text: "Top 10 Bahrain MBA Colleges"
    },
    {
      key: "top_15_oman_colleges",
      text: "Top 15 Oman Colleges"
    },
    {
      key: "top_10_oman_engineering_colleges",
      text: "Top 10 Oman Engineering Colleges"
    },
    {
      key: "top_10_oman_mba_colleges",
      text: "Top 10 Oman MBA Colleges"
    }]
export const EXPERIENCE_INSIGHTS_MAP = [
  {
    key: 'internal_promotion',
    text: 'Promoted in current company'
  },
  // {
  //   key: 'not_a_job_hopper',
  //   text: 'Not a job hopper'
  // },
  {
    key: 'startup_exp',
    text: 'Has startup experience'
  },
  {
    key: 'founded_a_company',
    text: 'Has a founder experience'
  },
  // {
  //   key: 'seen_company_ipo',
  //   text: "Seen company's IPO"
  // },
  // {
  //   key: 'seen_company_exit',
  //   text: "Seen company's exit"
  // },
  {
    key: 'early_employee_of_startup',
    text: "Early employee of a startup"
  },
  // {
  //   key: 'has_blog',
  //   text: "Has a blog"
  // },
  {
    key: 'has_portfolio',
    text: "Has a blog/portfolio"
  }
]

export const estimateSalaryTooltipMessage=`This is inferred from salary 
                                           information provided by multiple
                                            candidates working in similar 
                                            positions with similar companies`;
export const estimateNoticeTooltipMessage=`This is inferred from notice
                                           period information provided 
                                           by multiple candidates
                                           working in similar positions
                                           with similar companies`;


export const sourceIndexValue = 2;